import { Checkbox } from "@/components/ui/checkbox";
import type { IsSaveCardCheckboxProps } from "@/interfaces";
import { updateCardSave } from "@/services/PaymentService";
import { useSearchParams } from "react-router-dom";

const IsSaveCardCheckbox = ({
  saveCard,
  setSaveCard,
}: IsSaveCardCheckboxProps) => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("pi");
  return (
    <label className="flex items-center gap-3 mb-2">
      <Checkbox
        className="w-5 h-5"
        checked={saveCard}
        onCheckedChange={async (checked) => {
          const newValue = checked as boolean;
          setSaveCard(newValue);
          await updateCardSave({ saveCard: newValue, sessionId: sessionId! });
        }}
      />
      <p className="text-[#212121] font-['Poppins'] text-[12px] font-normal leading-[normal] text-edge-cap leading-trim-both">Save Card Details</p>
    </label>
  );
};

export default IsSaveCardCheckbox;
